import state from "./state";

export default {
  updateLastDateExumacaoTransladoUpdated() {
    state.last_update = new Date().getTime();
  }
};
